import React,{ useState, useEffect } from 'react';

import bkg_vigne from '../../assets/images/bkg-vigne.jpg';
import maison from "../../assets/images/maison.svg";

import pilier1 from "../../assets/images/prospection.svg";
import pilier2 from "../../assets/images/traitement.svg";
import pilier3 from "../../assets/images/arrachage.svg";
import pilier4 from "../../assets/images/maitrise.svg";

import {urlBase, urlDirectus} from "../../config/Globals";
import ArticleSevice from "../../service/Article";
import {Partenaires} from "../Home/Partenaires";
import PilierSevice from "../../service/PilierSevice";

export const Organisation = ({ rubrique }) => {

    const[piliers, setPiliers] = useState([]);
    const[loadingPiliers, setLoadingPiliers] = useState(1);
    const fetchPiliers = async() => {
        try{
            const data = await PilierSevice.findAll();
            setPiliers(data);
            setLoadingPiliers(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchPiliers();
    }, []);


    const[articles, setArticles] = useState([]);
    const[loadingArticles, setLoadingArticles] = useState(1);
    const fetchArticles = async(id) => {
        try{
            const data = await ArticleSevice.findAllInRubrique(id);
            setArticles(data);
            setLoadingArticles(false);
        }catch (error){

        }
    }
    useEffect(() => {
        if(rubrique.id) {
            fetchArticles(rubrique.id);
        }
    }, [rubrique.id]);

    return (
        <>
        <main className="type organisation-lutte">
            <section className="pt-md-5 pt-lg-0 pb-md-5 d-flex align-items-center bg-gris position-relative">
                <img src={bkg_vigne} alt="" className="hero-bg-image"/>
                <div className="container-top-custom-2 container-md px-md-4 pb-md-5 position-relative z-1">
                    <div className="row flex-column align-items-center justify-content-center">
                        <div className="col-12 col-lg-10 bg-white pb-5 p-4 p-md-5 position-relative d-flex flex-wrap">
                            <div className="col-12 col-xxl-6">
                                <nav aria-label="breadcrumb" className="mb-4">
                                    <ol className="custom-breadcrumb">
                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase} className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>

                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree'}
                                               className="breadcrumb-link">
                                                Tout savoir sur la flavescence dorée
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom active" aria-current="page">
                                            {rubrique.titre}
                                        </li>
                                    </ol>
                                </nav>
                                <h1 className="display-6 fw-sb mb-0">Les piliers de la lutte</h1>
                                <div className="col-12 piliers-container my-5 my-sm-0 position-relative d-flex flex-wrap">
                                    {piliers.map((pilier) => (
                                        <a
                                            key={pilier.id}
                                            href={urlBase+'tout-savoir-sur-la-flavescence-doree/'+rubrique.wording+'/'+pilier.wording}
                                            className={`${pilier.className} pilier-item d-flex align-items-center gap-3 text-decoration-none`}
                                        >
                                            {/* Si le texte doit être AVANT l'image */}
                                            {pilier.textPosition === "before" && (
                                                <span className={`${pilier.textClassName} pilier-text fw-sb`} dangerouslySetInnerHTML={{__html: pilier.text}}></span>
                                            )}

                                            <img
                                                src={urlDirectus+"assets/"+pilier.image}
                                                alt={pilier.titre}
                                                className="pilier-icon"
                                            />

                                            {/* Si le texte doit être APRÈS l'image */}
                                            {pilier.textPosition === "after" && (
                                                <span className={`${pilier.textClassName} pilier-text fw-sb`} dangerouslySetInnerHTML={{__html: pilier.text}}></span>
                                            )}
                                        </a>
                                    ))}
                                </div>
                            </div>
                            <div className="col-12 col-xxl-5 ms-auto margin-top-custom">
                                <div className="bg-beige p-4 p-md-5 d-flex flex-column">
                                    <div className="fw-b fs-5 mb-5">
                                        Quatre piliers de lutte complémentaires et indispensables face à la
                                        flavescence dorée. Une gestion aménagée grâce à une analyse de risque
                                        précise et une mobilisation de la profession exemplaire.
                                    </div>

                                    <div className="d-flex flex-column gap-3">
                                        {piliers.map((item) => (
                                            <div
                                                key={item.id}
                                                className="bg-white p-3 d-flex flex-wrap flex-xxl-nowrap align-items-center justify-content-between rounded-3"
                                                style={{ '--bs-bg-opacity': '.5' }} // Correction du format style en React
                                            >
                                                <div className="d-flex align-items-center gap-3">
                                                    <img
                                                        src={urlDirectus+"assets/"+item.image}
                                                        alt={item.titre}
                                                        className="flex-shrink-0"
                                                        style={{ width: '55px', height: '55px', objectFit: 'contain' }}
                                                    />
                                                    <h3 className="fs-6 fw-b text-dark mb-0">{item.titre}</h3>
                                                </div>

                                                <a
                                                    href={urlBase+'tout-savoir-sur-la-flavescence-doree/'+rubrique.wording+'/'+item.wording}
                                                    className="col-12 col-sm-auto mt-3 mt-sm-0 btn btn-mini btn-outline-custom text-uppercase fw-bold"
                                                >
                                                    Consulter
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-lg-5" id="savoir-plus">
                <div className="container px-4 py-5">
                    <h2 className="display-6 fw-sb mb-5 text-center">Plus d'informations</h2>

                    <div className="row g-5 justify-content-center">
                        {
                            articles.map((article, index) => (
                                    <div className="col-lg-6 d-flex">
                                        <div
                                            className="card border-0 rounded-0 w-100 card-bg-beige d-flex flex-column justify-content-between">
                                            <div className="text-center text-lg-start">
                                                <div className="p-4 p-xl-5">
                                                    <h3 className="fw-sb text-body mb-3">{article.titre}</h3>
                                                </div>
                                            </div>
                                            <div className="p-4 p-xl-5 pt-0 pt-xl-0 text-center text-lg-start">
                                                <a href={urlBase + "tout-savoir-sur-la-flavescence-doree/plus/" + rubrique.wording + '/' + article.id}
                                                   className="btn btn-outline-custom d-inline-block">En savoir plus</a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </section>
            <Partenaires/>
        </main>
        </>
    );
}